import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useParams } from 'react-router-dom';
import { ServicePlanItemPricingPolicy } from 'src/features/servicePlanPricingPolicies/utils/types';
import { useCreateServicePlanPricingPolicy } from 'src/features/servicePlanPricingPolicies/api/useCreateServicePlanPricingPolicy';
import { LIST_SERVICE_PLAN_PRICING_POLICIES_RESOURCE } from 'src/features/servicePlanPricingPolicies/api/useListServicePlanPricingPolicies';
import { pricingPoliciesMessages } from 'src/features/servicePlanPricingPolicies/utils/messages';
import ServicePlanPricingPolicyFormModal from 'src/features/servicePlanPricingPolicies/components/forms/ServicePlanPricingPolicyFormModal';

interface CreateServicePlanPricingPolicyFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedServicePlanPricingPolicy?: ServicePlanItemPricingPolicy;
    children?: React.ReactNode;
}

function CreateServicePlanPricingPolicyFormModal<TData>({
    className,
}: CreateServicePlanPricingPolicyFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { servicePlanItemId = '' } = useParams();

    const { mutate, isPending } = useCreateServicePlanPricingPolicy({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SERVICE_PLAN_PRICING_POLICIES_RESOURCE] });
            toast({
                title: formatMessage(pricingPoliciesMessages.createServicePlanPricingPolicySuccess),
                description: formatMessage(pricingPoliciesMessages.createServicePlanPricingPolicySuccessDescription),
            });
        },
    });

    return (
        <ServicePlanPricingPolicyFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ ...values, servicePlanItemId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, {
                entry: formatMessage(pricingPoliciesMessages.pricingPolicy).toLowerCase(),
            })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(pricingPoliciesMessages.addServicePlanPricingPolicySubtitle)}
        />
    );
}

export default CreateServicePlanPricingPolicyFormModal;
